export default {
	InvitationCode: "Invitasjonskode",
	CreditScore: "Kredittvurdering",
	MyFinancial: {
		title: "Mine Finansielle",
		menu: ["Innskudd", "Uttak", "Transaksjon"]
	},
	MyDetail: {
		title: "Min Detalj",
		menu: ["Personlig Informasjon", "Betalingsmetoder"]
	},
	Other: {
		title: "Annet",
		menu: ["Kontakt oss", "Varsler", "Endre språk"]
	},
	Amount: ["Lommeboksaldo", "Frosset saldo", "Dagens inntjening"],
	Logout: {
		title: "Logg ut",
		content: "Er du sikker på at du vil logge ut?"
	}
};
